/**
 * Auth — magic-link flow, sessions, the public user shape.
 *
 * The magic-link flow:
 *   1. Client POSTs `MagicLinkRequest` to `/api/v0/auth/magic-link`.
 *   2. Server emails a single-use link of the form
 *      `{API_BASE}/api/v0/auth/verify?token=…`.
 *   3. Visiting that URL consumes the token, sets a session cookie, and
 *      302s to `redirectTo` (or `/my-documents`).
 *   4. Frontend uses `GET /api/v0/auth/session` to hydrate state on load.
 */
export const DEFAULT_USER_PREFERENCES = {
    highlightColor: '#ffff00',
};
//# sourceMappingURL=auth.js.map